import { ComponentType, SVGProps } from 'react'

export const IllustrationSizes = ['sm', 'md', 'lg'] as const
export type IllustrationElement = SVGSVGElement
export type IllustrationSize = (typeof IllustrationSizes)[number]
export type IllustrationComponent = ComponentType<IllustrationProps>

export interface IllustrationProps extends SVGProps<IllustrationElement> {
  size?: IllustrationSize
  className?: string
}

export type IllustrationComponentType = {
  (props: IllustrationProps): JSX.Element
  displayName: string
  __wrappedIllustration: true
}
